import {
  GatewayConformite,
  GatewayGarantieFinanciere,
} from "@conformite/gateway";
import { userSession } from "@src/data/session/UserSession";

export class GarantieFinanciereApi {
  static async getAdmin(
    siren: string,
    millesime: number,
    categorie: GatewayConformite.IasIobsp
  ): Promise<
    | GatewayGarantieFinanciere.ConformiteGarantieFinanciereIas
    | GatewayGarantieFinanciere.ConformiteGarantieFinanciereIobsp
    | null
  > {
    const { data } = await userSession.axiosInstance.get<
      | GatewayGarantieFinanciere.ConformiteGarantieFinanciereIas
      | GatewayGarantieFinanciere.ConformiteGarantieFinanciereIobsp
      | null
    >(
      `/${GatewayGarantieFinanciere.garantieFinanciereUrl}/${siren}/${millesime}/${categorie}/admin`
    );
    return data;
  }
}
